// Numero de "panier" d'une operation, par opposition au numero de MARCHE (bon de commande / marche
// subsequent) qui n'est attribue qu'a l'acceptation.
//
// REGLE : un vrai numero s'ecrit `BC-...` / `MS-...` — prefixe suivi d'un TIRET. Tout le reste est un
// numero de panier. Deux formes de panier coexistent en base :
//   - `PBC02038` / `PMS00276` : prefixe complet
//   - `BC00165`  / `MS00123`  : le MEME numero sans le "P"
//
// Releve du 21/07/2026 : 959 BC et 93 MS portent un vrai numero (avec tiret). Les 1132 BC et 172 MS
// restants valent TOUS exactement "(P)BC" + id de l'operation paddee, sans une seule exception — la
// forme sans "P" est donc bien un placeholder, et non une notation plus ancienne.
const FORME_MARCHE = /^(BC|MS)-/i;

/**
 * Reconstruit le numero de panier canonique : prefixe + id de l'operation paddee a 5 chiffres.
 *   - MS -> "PMS" + id (operation 300 -> "PMS00300")
 *   - BC -> "PBC" + id (operation 2357 -> "PBC02357")
 * Retourne '' si l'id est absent.
 */
export const numeroPanier = (
  source: string | undefined,
  operationId: number | string | null | undefined,
): string => {
  if (operationId === null || operationId === undefined || operationId === '') {
    return '';
  }
  const prefix = source === 'MS' ? 'PMS' : 'PBC';
  return `${prefix}${String(operationId).padStart(5, '0')}`;
};

/**
 * Vrai si le numero est un numero de PANIER, donc si le marche n'est pas encore numerote.
 * Un numero absent compte comme un panier : il n'y a pas de numero de marche a montrer.
 */
export const estNumeroPanier = (numero?: string | number | null): boolean => {
  const valeur = String(numero ?? '').trim();
  if (valeur === '') return true;
  return !FORME_MARCHE.test(valeur);
};

/**
 * Numero de panier tel qu'AFFICHE : sans le prefixe ("PBC"/"PMS"/"BC"/"MS") ni les zeros de padding,
 * ce qui redonne l'id de l'operation. Aligne sur l'encart des bannieres de suivi, qui affiche l'id nu.
 * Un vrai numero est rendu tel quel : on ne mutile pas un numero contractuel.
 */
export const numeroPanierAffiche = (numero?: string | number | null): string => {
  const valeur = String(numero ?? '').trim();
  if (valeur === '' || !estNumeroPanier(valeur)) return valeur;
  const sansPrefixe = valeur.replace(/^P?(BC|MS)/i, '').replace(/^0+/, '');
  return sansPrefixe || '0';
};
